import { Table, message, Tag, Button } from "antd";
//redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useNavigate, useParams } from "react-router-dom";
import Url from "../../../apiCall/UrlConfig";
import { useEffect } from "react";
const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const ExamMainPage = (props) => {
  let navigate = useNavigate();
  const Columns = [
    {
      title: "Patien Id",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return <div style={{ textAlign: "center" }}>{item.id}</div>;
      },
    },
    {
      title: "lateral cephalometric ",
      dataIndex: "lateral cephalometric",
      key: "lateral cephalometric",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "laterall");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="lateral cephalometric"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "Analyses",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        if (item?.hasLateralCephaloAnalyse) {
          return <Tag color="#87d068">Analyses Done</Tag>;
        }
        return (
          <Button onClick={() => _onClickAnalyses(item.id)}>Analyses</Button>
        );
      },
    },
  ];
  useEffect(() => {
    _getListPatient();
  }, []);

  const _onClickAnalyses = (id) => {
    navigate(`/lateralchephalo/analyses/${id}`);
  };
  const _getListPatient = async () => {
    let url = Url.GetPatientForLateralCephaloExam;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  return (
    <div>
      <Table
        dataSource={
          props.coreData[Url.GetPatientForLateralCephaloExam]?.[Url.action]
            ?.data?.patients
        }
        columns={Columns}
        loading={
          props.coreData[Url.GetPatientForLateralCephaloExam]?.[Url.action]
            ?.isFetching
        }
      />
    </div>
  );
};
const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ExamMainPage);
